import React, { useState } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "../journey/step-library"
import { H2, Container, FlexContainer } from "@carrotfertility/carotene"
import { IlloYirTelehealth } from "../../../views/atoms/Illustrations"
import ArrowSubmitButton from "components/carrot-plans/shared/ArrowSubmitButton"
import { useMedicalInfo } from "../../context/MedicalInfoContext"

const step = Steps.WELCOME

export default function WelcomeStep(): JSX.Element {
  const { medicalInfo } = useMedicalInfo()
  const { setNextStep } = useStateMachine(step, medicalInfo ? "" : null)
  const title = "We have some optional health questions for the person seeking or receiving care."

  async function onClickContinue(): Promise<void> {
    setNextStep(step, "")
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onClickContinue()
      }}
    >
      <FlexContainer justifyContent="center" padding="none" stack="medium">
        <IlloYirTelehealth />
      </FlexContainer>
      <Container>
        <H2 stack="tiny">{title}</H2>
      </Container>
      <FlexContainer paddingTopBottom="huge" justifyContent="flex-end">
        <ArrowSubmitButton onClick={onClickContinue}>Continue</ArrowSubmitButton>
      </FlexContainer>
    </form>
  )
}
